import { useQuery } from 'react-query'
import axiosClient from '~/api/axiosClient'

export const LoginService = (source : string, query : string) => {
  const ssoApiURLService = useQuery(
    [],
    () => axiosClient.get(`/api/dt/Users/GetSSOURL?source=${source ?? ''}&query=${encodeURI(query ?? '')}`) as unknown as { url: string }
  )

  return { ssoApiURLService }
}
